export const acceptedFilesMap = {
    image: { 'image/png': ['.png', '.jpg', '.jpeg'] },
    video: { 'video/mp4': ['.mp4'] },
    chart: { 'image/svg': ['.svg'] },
    csv: { 'text/csv': ['.csv'] },
    audio: { 'audio/mpeg': ['.mp3', '.wav'] }
}
